import { FilterTypes, IContext, IFilter } from '@src/types';
import { atom, injectAtomValue, injectSelf, injectWhy } from '@zedux/react';
import { temporaryTopicAtom } from './atoms';
import { messagesAtomFamily } from './messagesAtomFamily';
import { topicsAtom } from './topicsAtom';


export const messageManagerAtom = atom('messageManager', (context: IContext, filter: IFilter) => {
    // 1. Get the list of all topic IDs
    const topics = injectAtomValue(topicsAtom, [context]);
    const temporaryTopic = injectAtomValue(temporaryTopicAtom, [context]);

    // Use ecosystem.getInstance instead of injectAtomInstance inside .map()
    // to avoid "injectors cannot be added, removed, or reordered" error
    const { ecosystem } = injectSelf();

    // 2. Use ecosystem.getInstance to keep every topic's message atom ALIVE
    // without violating Zedux's injector ordering rules
    const topicInstancesArr = topics.map(topic => [
        topic.topic_id,
        ecosystem.getInstance(messagesAtomFamily, [topic.topic_id, filter, context])
    ]);

    if (temporaryTopic && filter.type === FilterTypes.NO_FILTER) {
        topicInstancesArr.push([
            temporaryTopic.topic_id,
            ecosystem.getInstance(messagesAtomFamily, [temporaryTopic.topic_id, filter, context])
        ]);
    }

    // 3. Return the map of topic instances keyed by topic_id
    return Object.fromEntries(topicInstancesArr);
});
